import Quill from 'quill';
import QuillResizeModule from '@botom/quill-resize-module';
import registerIfNotRegistered from 'scaleflow/utils/quill-extenstions/registerIfNotRegistered';

const UNITLESS = /^\d+(\.\d+)?$/;

let imageWrapped = false;

// Images resized by the old quill-image-resize plugin were saved with a
// unitless `width` ("300", from the <img width> attribute). This module applies
// width and height as CSS, where a unitless value is invalid and dropped, so
// those images would load at full size. The module registers its image blot on
// its first instance, so wrap that blot once it exists and add the px.
function acceptUnitlessSizes(QuillClass) {
  if (imageWrapped) return;
  const ResizableImage = QuillClass.import('formats/image');
  class Image extends ResizableImage {
    format(name, value) {
      const isUnitless =
        (name === 'width' || name === 'height') && UNITLESS.test(value);
      super.format(name, isUnitless ? `${value}px` : value);
    }
  }
  QuillClass.register(Image, true);
  imageWrapped = true;
}

function ImageResize(quill, options) {
  const module = new QuillResizeModule(quill, options);
  acceptUnitlessSizes(quill.constructor);
  return module;
}

registerIfNotRegistered(Quill, 'modules/resize', ImageResize);

export default function imageResizeOptions(intl) {
  return {
    showSize: true,
    embedTags: ['img'],
    toolbar: { alignTools: true, sizeTools: false, attributesTool: false },
    locale: {
      altTip: intl.t('image-resize.zoom-tip'),
      floatLeft: intl.t('image-resize.align-left'),
      center: intl.t('image-resize.align-center'),
      floatRight: intl.t('image-resize.align-right'),
      restore: intl.t('image-resize.restore'),
      toolbarLabel: intl.t('image-resize.toolbar-label'),
      handlerLabel: intl.t('image-resize.handle-label'),
    },
  };
}
